import React, { useMemo } from "react";
import { ReactTable } from "../../components/table/ReactTable";
import { IPartOrderHistory } from "../../models/OrderManagement";
import { SelectColumnFilter } from "../../components/table/filters/SelectColumnFilter";
import { Column } from "react-table";
import { formatDate } from "../../helpers/utils/formatDate";

const MotorOrder = ({ data }: any) => {
  const columns: Column<IPartOrderHistory>[] = useMemo(
    () => [
      {
        Header: "Dealer Name",
        accessor: "dealerName",
        width: 200
      },
      {
        Header: "Sale Order",
        accessor: "orderNum",
        width: 120,
      },
      {
        Header: "Part Number",
        accessor: "partNum",
      },
      {
        Header: "Term",
        accessor: "term",
      },
      {
        Header: "Freight",
        accessor: "shipVia",
      },
      {
        Header: "Purchase Order",
        accessor: "poNum",
      },
      {
        Header: "Ordered Date",
        accessor: "orderDate",
        Cell: (cell: any) => (cell.value ? formatDate(cell.value) : ""),
      },
      {
        Header: "Status",
        accessor: "orderStatus",
        Filter: SelectColumnFilter,
      },
    ],
    []
  );

  return (
    <>
      <ReactTable<IPartOrderHistory>
        className="show-action-column"
        name="order-table"
        columns={columns}
        serverOnChange={false}
        data={data}
        isLoading={false}
      />
    </>
  );
};

export default MotorOrder;
